import styled from 'styled-components';
import { Button } from '@material-ui/core';

export const RetryButton = styled(Button)`
  margin-top: 16px;
`;
